export const response_planes_all = {
  description: 'Planes obtenidos correctamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string', example: 'Planes obtenidos correctamente' },
      data: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: { type: 'string', example: 'cd88ac6a-2b0e-41bc-afd9-24b594cb8daf' },
            codigo: { type: 'string', example: '1' },
            descripcion: { type: 'string', example: 'Demo' },
            precio: { type: 'number', example: 50000 },
            tipo_ciclo: { type: 'string', example: 'mensual' },
            max_user: { type: 'number', example: 1 },
            max_producto: { type: 'number', example: 10 },
            max_documentos: { type: 'number', example: 5 },
            periodo_prueba: { type: 'number', example: 7 },
            max_ducumento_prueba: { type: 'number', example: 5 },
            active: { type: 'boolean', example: true },
            created_at: { type: 'object', example: {} },
            updated_at: { type: 'object', example: {} },
            usuario: { type: 'string', nullable: true, example: null },
          },
        },
      },
    },
  },
};
